export const assetURLs = {
  'isoGrid': new URL('./iso_grid.png', import.meta.url).href,
};